import 'antd/lib/button/style';

export * from 'antd/lib/button';
export { default as Button } from 'antd/lib/button';
